module.exports = __webpack_public_path__ + "static/media/coach-gen2.48d8c67e.png";